import React from 'react';
import ReactDOM from 'react-dom/client';
// En premier : fixe la langue (francais par defaut) et celle de dayjs avant
// qu'un module ne formate une date.
import './i18n';
import LocalisationProvider from './i18n/LocalisationProvider';
import 'react-toastify/dist/ReactToastify.css';
import './theme/variables.css';
import App from './App';
import { renouvelerSilencieusement } from './services/renouvellementSession';
import { getToken, getRefreshToken } from './variables/constants';

const antdTheme = {
  token: {
    colorPrimary: '#1a6b3c',
    colorPrimaryHover: '#28804e',
    colorLink: '#1a6b3c',
    borderRadius: 8,
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14,
    colorBgContainer: '#ffffff',
    colorBorder: '#e5e7eb',
    colorText: '#111827',
    colorTextSecondary: '#6b7280',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  },
  components: {
    Button: { colorPrimary: '#1a6b3c', algorithm: true },
    Table: { headerBg: '#f4f6f5', borderColor: '#e5e7eb' },
    Menu: { itemSelectedBg: '#e8f5ed', itemSelectedColor: '#1a6b3c' },
    Tabs: { inkBarColor: '#1a6b3c', itemSelectedColor: '#1a6b3c' },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const monter = () => root.render(
  <LocalisationProvider theme={antdTheme}>
    <App />
  </LocalisationProvider>
);

/**
 * « Se souvenir de moi » : restaurer la session AVANT de monter l'application.
 *
 * Le jeton d'accès vit dans `sessionStorage` et meurt avec l'onglet ; seul le
 * jeton de rafraîchissement a survécu. Il faut échanger l'un contre l'autre
 * avant le premier rendu, sinon `ProtectedRoute` voit une session absente et
 * renvoie vers /login - l'utilisateur verrait l'écran de connexion apparaître
 * puis disparaître, ce qui est pire que pas de fonction du tout.
 *
 * Ce détour ne concerne QUE l'onglet neuf d'un utilisateur qui s'est souvenu :
 * dans tous les autres cas, l'application est montée immédiatement.
 */
if (!getToken() && getRefreshToken()) {
  // Jamais bloquant : `renouvelerSilencieusement` avale ses propres erreurs et
  // rend `false`. On monte dans tous les cas, avec ou sans session restaurée.
  renouvelerSilencieusement().finally(monter);
} else {
  monter();
}
